import { useAuth } from "../contexts/AuthContext";
import { useWebSocketNotifications } from "../hooks/useWebSocket";

/**
 * Lightweight global WebSocket connector that keeps a single notifications
 * socket open for the whole app (as long as a user is logged in), independent
 * of which route is active. The hook already broadcasts every incoming
 * message on the `trigo:ws-message` CustomEvent so listeners like
 * `AdminFlashModal` receive events on any page, not only the dashboards.
 */
export default function GlobalWSConnector() {
  const { user } = useAuth();
  // Intentionally ignore the returned state — the hook's side-effect (opening
  // the WS + dispatching the window event) is what matters here.
  useWebSocketNotifications(user?.id);
  return null;
}
